import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { Collapse as AntCollapse, Row, Space, Typography } from 'antd'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useScroll } from 'app/lib/hooks/useScroll'
import React, { ComponentProps, useState } from 'react'
import testIds from 'test_ids.json'

interface Props extends ComponentProps<typeof AntCollapse> {
  children?: React.ReactNode
  header: React.ReactNode
  headerCollapsed?: React.ReactNode
  defaultExpanded?: boolean
}

const { Panel } = AntCollapse

const key = 'single-item'

const KSingleCollapse: React.FC<Props> = ({
  defaultExpanded,
  children,
  header,
  headerCollapsed,
  ...others
}) => {
  const [activeKey, setActiveKey] = useState(defaultExpanded ? key : null)
  const { tComponent } = ToolBox.useString()
  const { ref, scroll } = useScroll()

  const expanded = key === activeKey

  const toggleExpanded = () => {
    setActiveKey(expanded ? null : key)
    scroll()
  }

  const translate = (id: string) =>
    tComponent({
      id,
      componentName: 'collapse',
      componentType: 'data_display'
    })

  const renderHeader = () => {
    if (headerCollapsed && !expanded) {
      return headerCollapsed
    } else {
      return header
    }
  }

  return (
    <Row gutter={[0, 12]} ref={ref}>
      <KCol span={24}>
        <AntCollapse activeKey={activeKey} className="single-collapse" accordion ghost {...others}>
          <Panel key={key} showArrow={false} header={renderHeader()}>
            {children}
          </Panel>
        </AntCollapse>
      </KCol>
      <KCol span={24} className="text-center">
        <Typography.Link
          underline
          onClick={toggleExpanded}
          data-testid={testIds.ui_elements.data_display.KSingleCollapse.expand_toggle}>
          <Space direction="horizontal">
            <span>{expanded ? translate('hide_details') : translate('show_details')}</span>
            {expanded ? <UpOutlined /> : <DownOutlined />}
          </Space>
        </Typography.Link>
      </KCol>
    </Row>
  )
}

export default KSingleCollapse
